const slateA = {
  slateA1: "hsla(0, 0%, 0%, 0)",
  slateA2: "hsla(181, 98.9%, 91.8%, 0.026)",
  slateA3: "hsla(182, 86.7%, 91.4%, 0.057)",
  slateA4: "hsla(209, 86.7%, 93.9%, 0.083)",
  slateA5: "hsla(200, 90.3%, 93.4%, 0.109)",
  slateA6: "hsla(209, 95.3%, 93.5%, 0.139)",
  slateA7: "hsla(204, 98.5%, 93.9%, 0.182)",
  slateA8: "hsla(209, 94.0%, 94.7%, 0.265)",
  slateA9: "hsla(207, 97.3%, 94.0%, 0.412)",
  slateA10: "hsla(209, 99.4%, 95.2%, 0.472)",
  slateA11: "hsla(208, 98.7%, 96.8%, 0.615)",
  slateA12: "hsla(211, 86.7%, 99.6%, 0.927)"
};
export { slateA };
//# sourceMappingURL=slateA.mjs.map
